import { createAsyncThunk } from "@reduxjs/toolkit";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL;

const uploadLabFiles = createAsyncThunk(
  "appointments/uploadLabFiles",
  async (
    {
      appointmentId,
      testId,
      files,
      labDescription,
      businessName,
      businessId,
    },
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();

      formData.append("appointmentId", appointmentId);
      formData.append("testId", testId);
      formData.append("labDescription", labDescription || "");
      formData.append("businessName", businessName || "");
      formData.append("businessId", businessId || "");

      if (Array.isArray(files)) {
        files.forEach((file) => {
          if (file) formData.append("files", file);
        });
      }

      const response = await fetch(
        `${baseUrl}/appointments/upload-lab-files`,
        {
          method: "POST",
          body: formData,
        }
      );

      let data;
      try {
        data = await response.json();
      } catch {
        return rejectWithValue("Invalid server response");
      }

      if (!response.ok) {
        return rejectWithValue(data?.message || "Upload failed");
      }

      return {
        testId,
        labFiles:
          data?.data?.labFiles ||
          data?.data?.files ||
          [],
        labDescription:
          data?.data?.labDescription || labDescription || "",
        raw: data?.data,
      };
    } catch (err) {
      return rejectWithValue(
        err.message || "Unknown upload error"
      );
    }
  }
);

export default uploadLabFiles;
